"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
require("./hide-entire-report.controller");
var hide_entire_report_html_1 = __importDefault(require("./hide-entire-report.html"));
require("./hide-entire-report.less");
function HideEntireReport() {
    return {
        templateUrl: hide_entire_report_html_1.default,
        controller: 'prHideEntireReportController'
    };
}
(function (angularModule) {
    angularModule.directive('prHideEntireReport', HideEntireReport);
})(angular_1.default.module('qualtrics.pr'));
exports.default = HideEntireReport;
